<template>
    <div class="app-inner">
        <div class="public-btn-div public-btn-small flex align-cen" style="padding-left:0">
                <div class="public-add" @click="addJob">
                    新增职位
                </div>
         </div>
             <div class="p-tit-c">
                 <div class="businessList-filter">
                        <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">人才岗位名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="人才岗位名称" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">人才岗位ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="人才岗位ID" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                </div>
                <div class="businessList-filter-list flex align-cen">
                         <div class="fl-le flex align-cen">
                            <div class="label">职位分类：</div>
                            <el-select
                                v-model="value"
                                clearable
                                placeholder="请选择"
                                @change="classSelect"
                            >
                                <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                >
                                </el-option>
                            </el-select>
                     </div>
                  <div class="fl-rt flex align-cen">
                    <div class="label">学历要求：</div>
                    <el-select
                        v-model="value1"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options1"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                    </div>
                </div>
                <div class="businessList-filter-list flex align-cen">
                         <div class="fl-le flex align-cen">
                            <div class="label">工作地点：</div>
                            <el-select
                                v-model="value2"
                                clearable
                                placeholder="请选择"
                                @change="classSelect"
                            >
                                <el-option
                                v-for="item in options2"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                                >
                                </el-option>
                            </el-select>
                     </div>
                  <div class="fl-rt flex align-cen">
                    <div class="label">经验要求：</div>
                    <el-select
                        v-model="value3"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options3"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                    </div>
                </div>
                      <div class="businessList-filter-list flex align-cen">
                         <div class="fl-le flex align-cen">
                            <div class="label">招聘需求：</div>
                            <el-select
                                v-model="value4"
                                clearable
                                placeholder="请选择"
                                @change="classSelect"
                            >
                                <el-option
                                v-for="item in options4"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                                >
                                </el-option>
                            </el-select>
                     </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">工作类型：</div>
                    <el-select
                        v-model="value5"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options5"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                    </div>
                </div>
                   <div class="businessList-filter-list flex align-cen">
                    <div class="label">启用状态：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                            @click="allradio('')"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio" label="1" @change="classSelect">启用</el-radio>
                        <el-radio v-model="radio" label="0" @change="classSelect">禁用</el-radio>
                 </div>
                   <div class="businessList-filter-list flex align-cen">
                    <div class="label">应用官网分类：</div>
                    <div
                      style="color: red; padding-right: 20px; cursor: pointer"
                      @click="allradio(1)"
                    >
                      不限
                    </div>
                    <el-radio v-model="radio1" label="1" @change="classSelect">和隆优化官网</el-radio>
                    <el-radio v-model="radio1" label="2" @change="classSelect">和隆软件官网</el-radio>
                  </div>
                       <div class="businessList-filter-list flex align-cen">
                     <div class="label">创建时间：</div>
                      <el-date-picker
                            v-model="value6"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect"
                            >
                            </el-date-picker>
                  </div>
                             <div class="businessList-filter-list flex align-cen public-btn-small">
                            <div class="public-btn-small-primary" @click="classSelect">
                            搜索
                            </div>
                            <div class="public-btn-small-text" @click="reset">
                            重置筛选条件
                            </div>
      </div>
                 </div>
             </div>
                 <div class="businessList-container">
            <div class="businessList-container-table">
                    <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
        <el-table-column prop="id" label="人才岗位ID" align="center" width="150"></el-table-column>
        <el-table-column prop="name" label="岗位名称" align="center"></el-table-column>
          <el-table-column label="应用官网分类" align="center" prop="id" width="200">
          <template slot-scope="scope">
            <span>
              {{$util.offType(scope.row.officialType)}}
            </span>
          </template>
         </el-table-column>
        <el-table-column prop="classifyName" label="职位分类" align="center"></el-table-column>
        <el-table-column prop="workplace" label="工作地点" align="center" width="200"></el-table-column>
        <el-table-column prop="experience" label="经验要求" align="center"></el-table-column>
        <el-table-column prop="hiringNeeds" label="招聘需求" align="center"></el-table-column>
        <el-table-column prop="degree" label="学历要求" align="center"></el-table-column>
        <el-table-column prop="jobCategory" label="工作类型" align="center"></el-table-column>
             <el-table-column  label="收到简历" align="center">
            <template slot-scope="scope">
              <div style="color:red;cursor:pointer" @click="openDoc(scope.row)">{{scope.row.resumeNum || 0}}份</div>
            </template>
          </el-table-column>
            <el-table-column  label="创建时间" align="center" width="200">
                <template slot-scope="scope">
              <div>{{scope.row.createTime || '暂无'}}</div>
            </template>
            </el-table-column>
                 <el-table-column  label="启用状态" align="center">
            <template slot-scope="scope">
                <div class="buStatus" @click.stop="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
                        <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="250"          
            >
              <template slot-scope="scope" >
                <el-button type="text" size="small" @click="preview(scope.row)">预览</el-button>
                  <el-button type="text" size="small" @click="openPoster(scope.row)">查看链接海报</el-button>
                   <el-button type="text" size="small"  @click.stop="addJob(scope.row)">编辑</el-button>
                    <el-button type="text" size="small"  style="color:red" @click.stop="deletJob(scope.row)">删除</el-button>
            </template>
            </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
            </div>
         </div>
                         <el-dialog
  title="查看链接海报"
  :visible.sync="centerDialogVisible1"
  width="440px"
  :append-to-body="true"
  center>
     <div class="dia-can">
                 <vue-canvas-poster :widthPixels="370" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile(dowloadImgName,posterImg)">保存</div>
  <div class="linkdiv">
     岗位详情链接：{{link}}
    <span @click.stop="copy(link)" style="color:#409eff;cursor: pointer;">复制</span>
  </div>
</el-dialog>
    </div>
</template>
<script>
import { jobClassify,jobList,editJob,getJob} from "@/api/index/index"  //人才岗位分类、人才岗位列表、新增修改人才岗位、删除新闻
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
export default {
    name:'recruit',
      components:{
      paginaTion
    },
    data() {
        return {
            dowloadImgName:'人才岗位海报',
            userinfo:{},
            centerDialogVisible1:false,
            list:[],
            search:'',
            search1:'',
            value:'',
            value1:'',
            value2:'',
            value3:'',
            value4:'',
            value5:'',
            value6:'',
            radio:'',
            radio1:'',
             start_time:'',
            end_time:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            options:[
            ],
             options1:[
                {
                    id:1,
                    name:'初中及以下'
                },{
                    id:2,
                    name:'中专/中技'
                },{
                    id:3,
                    name:'高中'
                },{
                    id:4,
                    name:'大专'
                },{
                    id:5,
                    name:'本科'
                },{
                    id:6,
                    name:'硕士'
                },{
                    id:7,
                    name:'博士'
                }
            ],
            options2:[
                {
                    id:1,
                    name:'北京'
                },{
                    id:2,
                    name:'南京'
                },{
                    id:3,
                    name:'济南'
                },{
                    id:4,
                    name:'西安'
                },{
                    id:5,
                    name:'呼和浩特'
                },{
                    id:6,
                    name:'沈阳'
                },{
                    id:7,
                    name:'长沙'
                },{
                    id:8,
                    name:'鄂尔多斯'
                }
            ],
             options3:[
                {
                    id:1,
                    name:'在校生'
                },{
                    id:2,
                    name:'应届生'
                },{
                    id:3,
                    name:'1年以内'
                },{
                    id:4,
                    name:'1-3年'
                },{
                    id:5,
                    name:'3-5年'
                },{
                    id:6,
                    name:'5-10年'
                },{
                    id:7,
                    name:'10年以上'
                }
            ],
            options4:[
                {
                    id:1,
                    name:'社招'
                },{
                    id:2,
                    name:'校招'
                },
            ],
             options5:[
                {
                    id:1,
                    name:'全职'
                },{
                    id:2,
                    name:'兼职'
                },
            ],
             pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
             },
               link:'',
        posterImg:'',
          painting: {
                    width: '371px',
                    height: '460px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: require('../../../assets/images/to_pic1.jpg'),
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '371px',
                                height: '130px'
                            },
                        },
                         {
                            type:'image',
                            url: require('../../../assets/images/HeroopSys.png'),
                            css: {
                                top:'150px',
                                 width: "130px",
                                 height:"44px",
                                 textAlign: "center",
                                 left:"120.5px"
                            }
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'205px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                            type:'text',
                            text: '',
                            css: {
                                top:'225px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '250px',
                            left: '110px',
                            color: '#000',
                            width: '150px',
                            height: '150px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：北京和隆软件有限公司',
                            css: {
                                bottom:'20px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
           },
        }
    },
    activated() {
        this.gethisInfo()
        this.getjobClassify()
    },
    created () {
     this.userinfo = LocaStorage.setAge().get('userinfo')
    },
    methods: {
             // 打开预览
      preview(data){
        const newurl = this.$router.resolve({name: 'jobDetail', query: {id: data.id,type:1}})
        window.open(newurl.href,'_blank')
      },
                 // 复制链接
          copy(link){
             let _self = this
      this.$copyText(link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
    },
          // 海报绘制成功钩子
            success(src) {
             this.posterImg = src;
            },
              // 海报绘制失败钩子
            fail(err) {
                console.log('fail', err)
            },
         // 手动修改海报views
        handleChangeImg(data){
             this.painting.views[2].text =  this.userinfo.name + '给你分享了一个岗位，快来看看吧~~'
              this.painting.views[3].text =  data.name 
             this.painting.views[3].content = this.$config.prUrl + '#/webenterprise/jobDetail?id='+ data.id
        },
        // 打开链接海报
        openPoster(data){
             if(data.state == 1){
              this.centerDialogVisible1 = true
              this.handleChangeImg(data)
              this.dowloadImgName = data.name +'岗位海报'
              this.link = this.$config.prUrl + '#/webenterprise/jobDetail?id='+ data.id
            }else{
              this.$message.error('请先开启状态')
            }
        },
             // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 删除
           deletJob(data){
          if(data.state == '1') return this.$util.Notifi('您需要先禁用该岗位后方能删除，请先禁用轮播图','error','fa-exclamation-circle')
         this.$confirm('岗位删除后将无法继续展示，确认删除吗?', '删除岗位', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            getJob({
              id:data.id,
              },'delete')
                .then(res => {
                 if(res.code == 0){
                  this.$util.Notifi('删除成功','success','fa-check')
                  this.gethisInfo()
                 }else{
                  this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                 }
              })
              .catch(err => {
              })
        })
        },
        // 打开新增
            addJob(data){
                 data.id ? this.$router.push({name:'addRecruit',query:{id:data.id}}) : this.$router.push("/addRecruit")
            },
            // 打开建立
            openDoc(data){
                this.$router.push({name:'recruitDoc',query:{id:data.id}})
            },
            // 状态禁启用
           changeStatus(e){
             if(e.row.state == 0){
           this.$confirm('启用后不得随意删除人才岗位内容，请先进行预览，审核后再启用', '开启', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editApp(e)
                        }).catch(() => {          
                        });
        }else{
            this.editApp(e)
        }
      },
         editApp(e){
             editJob({
                id:e.row.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                    e.row.state == 1 ? this.$util.Notifi('已禁用','error','fa-exclamation-circle') : this.$util.Notifi('启用成功','success','fa-check')
                    this.gethisInfo()
                  }
                })
                .catch(err => {
                })
        },
        reset(){
            this.search = ""
          this.search1 = ""
          this.radio = ""
          this.radio1 = ""
          this.value = ""
          this.value1 = ""
          this.value2 = ""
          this.value3 = ""
          this.value4 = ""
          this.value5 = ""
          this.value6 = ""
          this.start_time = ""
          this.end_time = ""
          this.currentPage = 1
           this.gethisInfo()
        },
        allradio(type){
           this[`radio${type}`] = ""
          this.currentPage = 1
           this.gethisInfo()
        },
        // 筛选
        classSelect(){
            if(this.value6){
             this.start_time = this.value6[0]
            this.end_time = this.value6[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
            // 获取分类
        getjobClassify(){
         jobClassify({})
         .then(res =>{
          if(res.code == 0){
            this.options = res.data
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
          }
         })
         .catch(err =>{})
      },
        // 获取人才岗位列表
       gethisInfo(){
        let params = {
            name:this.search,
            id:this.search1,
            classifyId:this.value,
            degree:this.value1,
            workplace:this.value2,
            experience:this.value3,
            hiringNeeds:this.value4,
            jobCategory:this.value5,
            state:this.radio,
            officialType:this.radio1,
            createTimeStart:this.start_time,
            createTimeEnd:this.end_time,
            size:this.PageSize,
            current:this.currentPage,
        }
         jobList(params)
          .then(res => {
            this.list = res.data.records
            this.totalCount = res.data.total
           
          })
          .catch(err => {

          })
       },
    },
}
</script>
<style lang="scss" scoped>
  ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
           .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
           .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
  }
</style>